<template>
    <div>
        <Breadcrumbs main="Bank Soal" title="Jawaban"/>
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row">

                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-header">
                            <h5>Form Pengisian Jawaban</h5>                            
                        </div>
                        <form class="needs-validation" @submit="handleSubmit">
                            <div class="card-body">                                                                
                                <!-- mulai form kelas -->                                
                                <div class="row">
                                    <div class="col">
                                        <div class="form-group">
                                            <h6>Soal : {{ titleSoal }}</h6>
                                            <p>&nbsp;</p>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="row">
                                    <div class="col">
                                        <div class="form-group">
                                            <label>Jawaban</label>
                                            <vue-editor v-model="form_data.jawaban_detail" :state="form_data_result.jawaban_detail"></vue-editor>
                                            
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col">
                                        <div class="form-group">
                                            <label>Status Jawaban</label>
                                            <b-form-select v-model="form_data.jawaban_benar" :options="statusJawabanOptions"></b-form-select>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col">
                                        <br>
                                    </div>
                                </div>
                                                                                                
                                <!-- end form kelas -->                                                                
                            </div>

                            <div class="card-footer">
                                <b-button type="submit" variant="primary" class="mr-1">Submit</b-button>
                                <b-button type="reset" variant="light">Cancel</b-button>
                            </div>
                        </form>
                    </div>

                </div>

            </div>

            <div class="row">
                <div class="col-md-12">
					<div class="card">
						<div class="card-header">
							<h5 class="card-title">Daftar Topik</h5>
						</div>
						<div class="card-body">
							<div class="table-responsive datatable-vue m-0 vue-smart">
								<v-table
										:data="allJawabanBySoal" class="table"
										:currentPage.sync="basic.currentPage"
										:pageSize="10"
										@totalPagesChanged="basic.totalPages = $event"
								>
									<thead slot="head">
									<v-th>No</v-th>
									<v-th>Jawaban</v-th>
                                    <v-th>Status Jawaban</v-th>                                    									                                    
									<v-th>Action</v-th>
									</thead>
									<tbody slot="body" slot-scope="{displayData}">
									<tr v-for="(row, index) in displayData" :key="row.id">
										<td>{{ row.id }}</td>

                                        <td v-if="index === indexEdit">
                                            <b-form-textarea v-model="form_data.jawaban_detail" rows="3">{{ row.jawaban_detail }}</b-form-textarea>
                                        </td>
										<td v-else><span v-html="row.jawaban_detail"></span></td>
                                        <td>{{ row.jawaban_benar ? "Benar" : "Salah" }}</td>										
										<td>                                                                                        
                                            
                                            <div style="display:flex; justify-content:space-between; align-items:center; width:60px;">                                                
                                                <feather style="cursor:pointer;" type="edit-2" stroke="blue" @click="editData(row, index)"></feather>
                                                <feather style="cursor:pointer;" type="trash-2" stroke="red" @click="deleteData(row)"></feather>
                                            </div>
                                        </td>									
									</tr>
									</tbody>
								</v-table>

								<smart-pagination
										:currentPage.sync="basic.currentPage"
										:totalPages="basic.totalPages"
								/>
							</div>
						</div>
					</div>
				</div>
            </div>
            
        </div>
        <!-- Container-fluid Ends-->

        <div class="loader" v-if="loader"></div>
    </div>
</template>

<script>
    import vue2Dropzone from 'vue2-dropzone';
    import datatopik from '../../data/topik'
    import {url} from "@/urls";
    import {service} from '@/services';
    import * as _ from 'underscore';
    import { VueEditor } from "vue2-editor";

    export default {
        data(){
            return{
                currentJawabanId: null,
                isEditForm: false,
                content: "",
                currentSoal: {},
                idsoal: null,
                titleSoal: "",

                tipePertamaSoal: "",
                indexEdit: -1,
                allJawabanBySoal: [],
                allTopikByTenant: [],
                datatopik,

                basic:{
                    currentPage: 1,
                    totalPages: 0,
			    },

                form_data:{
                    idtenant: localStorage.getItem("idtenant"),
                    idsoal: null,
                    jawaban_detail: "",
                    jawaban_gambar: "",
                    jawaban_benar: "f",
                    jawaban_benar: "f"                    
                },
                loader:false,

                form_data_result:{
                    jawaban_detail: null                    
                },                                              

                statusJawabanOptions:[
                    { value:"f", text: "Salah"},                        
                    { value:"t", text: "Benar"}
                ]                   
            }
        },
        methods: {
            saveData(data) {
                this.loader = true;
                // this.form_data.password = this.form_data.nis;
                let body = {
                    soal: this.form_data.jawaban_detail,
                    // idtopik: this.form_data.idtopik,
                    // tipe: this.form_data.jawaban_benar,
                    // picurl: this.form_data.picurl,
                }

                service.onUpdate(`${url.soal}/${data.id}`, body)
                .then(result => {
                    setTimeout(() => {
                        this.loader = false;
                        this.$toasted.show(" Data Soal berhasil diubah ", {theme: 'outline',position: "top-right", type: 'success', duration: 3000});
                    }, 1000);                        
                    console.log(result.data);
                    this.getSoalById()
                    this.resetForm()				
                }).catch(error => {
                    setTimeout(() => {
                        // eslint-disable-next-line
                        console.log(error);
                        this.$toasted.show(" Terjadi kesalahan input, silahkan diulangi kembali ", {theme: 'outline',position: "top-right", type: 'error', duration: 3000});
                        this.loader = false;
                    }, 1000);
                    this.resetForm()
                })
            },
            resetForm() {                                
                this.$data.form_data.jawaban_detail = ''
                this.$data.form_data.jawaban_benar = "f"
                
                this.$data.indexEdit = -1
            },
            editData(data, index) {                   
                console.log(data);
                this.currentJawabanId = data.id             
                this.$data.form_data.jawaban_detail = data.jawaban_detail                
                this.$data.form_data.jawaban_benar = data.jawaban_benar ? "t" : "f"    
                this.$data.indexEdit = -1
                this.isEditForm = true
            },
            addJawabanPg(data, index) {
                console.log(data, 'add pg')
            },
            deleteData(data) {
                 console.log(data, 'delete')
                this.$swal({
                    icon: 'warning',
                    title: `Apakah anda yakin`,
                    text : `ingin menghapus soal "${data.soal}" ?`,
                    showCancelButton: true,
                    cancelButtonText: `Tidak`,
                    confirmButtonText: `Ya`,
                }).then((res) => {
                    if (res.isConfirmed) {
                        service.onDelete(`${url.jawaban}/${data.id}`)
                        .then((resultDelete) => {
                            if (resultDelete) {
                                this.$swal(
                                    'Terhapus!',
                                    'Data berhasil dihapus.',
                                    'success'
                                )
                                this.getAllJawaban();            
                                //this.getSoalById()
                            }
                        })
                        // eslint-disable-next-line
                        .catch((errDelete) => {
                            this.$swal({
                                icon: 'error',
                                title: 'Oops...',
                                text: 'Terjadi Kesalahan!',
                            })
                        })
                    }
                })
            },
            warningSoalEssayUpload() {
                // Hanya untuk 1 buah soal
                this.$data.form_data.jawaban_benar = "ESSAY";
                this.$swal({
                    icon: 'warning',
                    title: `Error`,
                    text : `Untuk Essay Upload hanya boleh 1 soal saja`,
                    showCancelButton: false,                    
                    confirmButtonText: `Ok`,
                }).then((res) => {
                    //
                })
            },
            uploadSuccess(file, response) {
                console.log(file)
                console.log('File Successfully Uploaded with file name: ' + response);
                this.form_data.picurl = response;
            },
            changeTipeSoal(evt) {
                if (this.form_data.jawaban_benar === "ESSAY_UPLOAD" && this.allJawabanBySoal.length > 0) {
                    this.warningSoalEssayUpload();
                } 
            },
            changeTopik(evt) {
                console.log(this.form_data.idtopik);
                this.getSoalById();
            },
            handleSubmit(evt) {
                evt.preventDefault();
                if(this.form_data.jawaban_detail != '')
                {
                    this.form_data_result.jawaban_detail = true
                }
                else
                {
                    this.form_data_result.jawaban_detail = false
                }

                if (this.form_data.jawaban_detail != "") {
                    
                    this.loader = true;
                    
                    let body = _.clone(this.form_data);
                    console.log(body);

                    if (this.isEditForm) {
                                                

                        service.onUpdate(`${url.jawaban}/${this.currentJawabanId}`, body)
                        .then(result => {
                            setTimeout(() => {
                                this.loader = false;
                                this.$toasted.show(" Data Jawaban berhasil diubah ", {theme: 'outline',position: "top-right", type: 'success', duration: 3000});
                            }, 1000);                        
                            console.log(result.data);
                            this.getAllJawaban();
                            this.resetForm()
                            this.isEditForm = false				
                        }).catch(error => {
                            setTimeout(() => {
                                // eslint-disable-next-line
                                console.log(error);
                                this.$toasted.show(" Terjadi kesalahan input, silahkan diulangi kembali ", {theme: 'outline',position: "top-right", type: 'error', duration: 3000});
                                this.loader = false;
                            }, 1000);
                            this.resetForm()
                        })
                    } else {
                        service.onPost(url.jawaban, body)
                        .then(result => {
                            setTimeout(() => {
                                this.loader = false;
                                this.$toasted.show(" Jawaban berhasil disimpan ", {theme: 'outline',position: "top-right", type: 'success', duration: 3000});
                            }, 1000);
                            this.getAllJawaban();
                            this.resetForm()                                      
                            console.log(result.data);					
                        }).catch(error => {
                            setTimeout(() => {
                                // eslint-disable-next-line
                                console.log(error);
                                this.$toasted.show(" Terjadi kesalahan input, silahkan diulangi kembali ", {theme: 'outline',position: "top-right", type: 'error', duration: 3000});
                                this.loader = false;
                            }, 1000);
                        })
                    }                    
                    
                }
            },
            getAllJawaban(){
                service.onGet(url.get_jawaban_by_soal + "/" + this.idsoal)
                .then(result => {            
                    if (result.data) {    
                        console.log('jawaban_detail soal', result.data.length, result.data)                    
                                               
                        this.allJawabanBySoal = result.data;
                    } 
                }).catch(error => {
                    console.log(error)
                })                          
            },
            getAlllSoalByTenant(){            
                service.onGet(url.soal_get_by_tenant + "/" + localStorage.getItem("idtenant"))
                .then(result => {            
                    if (result.data) {
                        this.allJawabanBySoal = result.data;
                    }
                }).catch(error => {
                    console.log(error)
                })
            },
            getSoalById(){            
                service.onGet(url.soal + "/" + this.idsoal)
                .then(result => {            
                    if (result.data) {    
                        this.currentSoal = result.data;
                        this.titleSoal = this.currentSoal.soal;
                    } else {
                        this.tipePertamaSoal = "";
                        this.allJawabanBySoal = [];
                    }
                }).catch(error => {
                    console.log(error)
                })
            },
            clearFile() {
                this.$refs.myVueDropzone.removeAllFiles()
                console.log('file di remove')
            }
        },
        mounted() {            
            this.idsoal = this.$route.params.idsoal;
            this.form_data.idsoal = this.idsoal;
            this.getSoalById();
            this.getAllJawaban();            
        },
        components: {
            vueDropzone: vue2Dropzone,
            VueEditor
        }
    }
</script>